module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/rain-5-4b764b430655a84c67869136531e7f7a.svg";